import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { cl } from "../helpers/general";

interface Props {
  title: string;
  subtitle: string;
  link: string;
  thumbnail: any;
  type?: string;
  className?: string;
}

const TYPE_COLORS: any = {
  article: "bg-green-700",
  event: "bg-blue-700",
  contest: "bg-red-700",
};

export const EventCard = (props: Props) => {
  return (
    <Link
      to={`/events/${props.link}`}
      className={cl(
        "rounded-xl overflow-hidden bg-brand-four relative block w-full",
        props.className
      )}
    >
      <GatsbyImage
        alt=""
        image={getImage(props.thumbnail)!}
        className="w-full"
      />
      <div className="p-6">
        <div className="text-lg">{props.title}</div>
        <div className="opacity-50 mt-2 text-sm">{props.subtitle}</div>
      </div>
      <div
        className={cl(
          "absolute right-0 top-0 m-2 rounded-md px-2 py-1 text-xs",
          TYPE_COLORS[props.type as any] || ""
        )}
      >
        {props.type?.toUpperCase()}
      </div>
    </Link>
  );
};
